import React, { useState, useEffect } from "react";
import axios from "axios";
import LongTermAssetsModal from "./LongTermAssetsModal";
import LongTermAssetsViewModal from "./LongTermAssetsViewModal";
import "../../Style/TableStyle.scss";
import "../../Style/__searchbar.scss";
import "../../Style/__button.scss";
import "./LongTermAssetsPage.scss";
import { deleteAlert, errorAlert, handleSuccess } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { AiFillCar } from "react-icons/ai";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DataGridWithActions from "../../Components/DataGridWithActions";
import CrudPageHeader from "../../Components/CrudPageHeader";

export default function LongTermAssetsPage() {
  const headers = authHeader();
  const [data, setData] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [viewAsset, setViewAsset] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "Accounts/LongTermAssets", { headers });
      setData(response.data);
    } catch (error) {
      if (error?.response?.data?.errorMessage) {
        errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
      } else if (error?.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë.");
      }
    }
  };

  const handleEdit = (item) => {
    setSelectedAsset(item);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedAsset(null);
  };

  const handleView = (item) => {
    setViewAsset(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setViewAsset(null);
  };

  const handleDelete = async (deleteItemId) => {
    try {
      const response = await axios.delete(
        ApiLink.API_URL + "Accounts/assets" + `/${deleteItemId}`,
        { headers }
      );
      const result = response.data;
      if (result.success) {
        handleSuccess("Aseti është fshirë me sukses");
        fetchData();
      } else {
        deleteAlert("Aseti nuk mund të fshihet sepse është përdorur në transaksione");
      }
    } catch (error) {
      deleteAlert("Ka ndodhur një gabim gjatë fshirjes së asetit.");
    }
  };

  const assetsGridHeader = [
    {
      field: "id",
      headerName: "#",
      width: 60,
      headerClassName: "super-app-theme--header",
      sortable: false,
      filterable: false,
      groupable: false,
      aggregable: false,
    },
    {
      field: "AccountName",
      headerName: "Emri i Asetit",
      flex: 2.6,
      minWidth: 320,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "LedgerNameEN",
      headerName: "Llogaria Kontabël",
      flex: 1.2,
      minWidth: 200,
      editable: false,
      headerClassName: "super-app-theme--header",
      groupable: false,
      aggregable: false,
    },
    {
      field: "IsActive",
      headerName: "Aktiv",
      width: 90,
      headerClassName: "super-app-theme--header",
      renderCell: (params) =>
        params.value ? <CheckCircleOutlineIcon style={{ color: "green" }} /> : "",
    },
  ];

  const rows = data.map((item, index) => ({
    id: index + 1,
    AccountName: item.AccountName,
    LedgerNameEN: item.LedgerNameEN,
    IsActive: Boolean(item.IsActive),
    deleteItemId: item.AccountID,
    rowInfo: item,
  }));

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="Crud__Container LTA__page">
      <LongTermAssetsModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        mode="edit"
        initialData={selectedAsset}
        fetchData={fetchData}
      />

      <LongTermAssetsViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        assetData={viewAsset}
      />

      <CrudPageHeader
        icon={AiFillCar}
        title="Lista e Aseteve Afatgjata"
        description="Forma e Aseteve: Menaxhoni, shtoni, editoni dhe fshini Asete."
        tutorialUrl="https://www.youtube.com/@Accountree"
        tutorialLabel="Shiko Tutorialin"
        action={
          <LongTermAssetsModal
            fetchData={fetchData}
            type="text"
            className="button-68"
          />
        }
        className="LTA__header"
      />

      <DataGridWithActions
        columns={assetsGridHeader}
        rows={rows}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleShowPrint={handleView}
        showPayment={false}
        height={500}
        showDetailsStatus={true}
        modernStyle={true}
      />
    </div>
  );
}